import { SymbolPool } from '@1x2network/reel_set'
import { slotStore } from '@1x2network/slot-ui'
import { CustomSymbol } from '../CustomSymbol'
import { SymbolModel } from '../model/SymbolModel'
import { isValueSymbol } from '../types/typeGuards'
import { times } from '../utils/times'

/**
 *
 * Pool constructing symbols specifically for this game
 * @author Jordan Harrison - <jordan.harrison@1x2network.com>
 * @version 1.0.0
 */
export class CustomSymbolPool extends SymbolPool<CustomSymbol, SymbolModel, SymbolModel> {
    /**
     * Create a symbol to represent a landed symbol
     * @param args - data to construct the symbol with, defaults
     * @returns land symbol
     */
    requestLandSymbol(args: SymbolModel): CustomSymbol {
        const symbol = this.createSymbol(args)

        if (!isValueSymbol(args)) {
            return symbol
        }

        if (args.cash.start.currency) {
            symbol.updateTextValue(args.cash.start.currency)
        } else {
            // Symbols that land above and below the reels won't have a currency value but we don't want the text to disappear as it lands.
            symbol.updateTextValue(args.cash.start.timesStake)
        }

        const sub = slotStore.subscribe(
            (state) => {
                return state.stake.current.currency
            },
            (state) => {
                symbol.updateTextValue(times(state, args.cash.end.timesStake))
            },
        )
        symbol.stakeSub = sub

        return symbol
    }

    /**
     * Create a symbol to represent a spinning symbol
     * @param args - data to construct the symbol with, defaults
     * @returns spin symbol
     */
    requestSpinSymbol(args: SymbolModel): CustomSymbol {
        const symbol = this.createSymbol(args)

        if (isValueSymbol(args)) {
            symbol.updateTextValue(args.cash.start.timesStake)
        }

        return symbol
    }
}
